import { SALES_NAME_PREFIX } from "../../../i18n/i18n";

const getTranslationKeyByCategoryId = (categoryId: string) => ({ id: `${SALES_NAME_PREFIX}.${categoryId}` });

export { getTranslationKeyByCategoryId };
